import React from 'react';
import ReactDOM from 'react-dom';
import { FaCheck } from 'react-icons/fa';

const TaskItem = ({ task, onToggle }) => {
  const Icon = task.icon;

  return (
    <div className="p-4 rounded-lg bg-green-50 transition-colors flex items-center">
      <button
        onClick={() => onToggle(task.id)}
        className="w-6 h-6 rounded-full border-2 flex items-center justify-center border-green-500 bg-green-500"
      >
        <FaCheck className="text-white text-xs" />
      </button>
      <div className="flex-1 ml-4">
        {task.type === 'apps' ? (
          <p className="text-sm font-medium text-gray-800">Applied to {task.company_name}</p>
        ) : task.type === 'leetcode' ? (
          <p className="text-sm font-medium text-gray-800">Did Leetcode problem: {task.name}</p>
        ) : task.type === 'lessons' ? (
          <p className="text-sm font-medium text-gray-800">Complete "{task.lesson_name}" lesson</p>
        ) : (
          <>
            <p className="text-sm font-medium text-gray-800">
              {task.name || task.lesson_name || task.task_name || 'Untitled Task'}
            </p>
            {task.difficulty && <p className="text-xs text-gray-500">{task.difficulty}</p>}
          </>
        )}
      </div>
      <div className="flex items-center space-x-2">
        <div className={`p-2 rounded-full bg-${task.color}-100`}>
          <Icon className={`text-${task.color}-500`} />
        </div>
      </div>
    </div>
  );
};

const EditProgressModal = ({ isOpen, onClose, tasks, onToggleTask }) => {
  if (!isOpen) return null;

  const completedTasks = tasks.filter((task) => task.completed);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-60 overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal */}
        <div className="relative transform overflow-hidden rounded-xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
          <div className="flex justify-between items-center p-6 border-b">
            <h2 className="text-xl font-semibold">Edit Progress</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>
          <div className="p-6 max-h-[60vh] overflow-y-auto">
            <div className="space-y-3">
              {completedTasks.length > 0 ? (
                completedTasks.map((task) => (
                  <TaskItem key={task.id} task={task} onToggle={onToggleTask} />
                ))
              ) : (
                <p className="text-gray-500 text-center py-4">No completed tasks to edit</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root') || document.body
  );
};

export default EditProgressModal;
